const periodType = {
  daily: 'Diário',
  weekly: 'Semanal',
  monthly: 'Mensal',
  bimonthly: 'Bimestral',
  quarterly: 'Trimestral',
  semiannual: 'Semestral',
  annual: 'Anual',
}

const cardBrand = {
  'american-express': {
    image: 'amex',
    size: 2.6,
  },
  'diners-club': {
    image: 'diners',
    size: 2.1,
  },
  discover: {
    image: 'discover',
    size: 4.2,
  },
  elo: {
    image: 'elo-payment-link',
    size: 4.2,
  },
  hipercard: {
    image: 'hipercard',
    size: 3.8,
  },
  mastercard: {
    image: 'mastercard',
    size: 2.7,
  },
  visa: {
    image: 'visa',
    size: 3.8,
  },
  default: {
    image: 'default',
    size: 1.7,
  },
}

const cardValidator = require('card-validator')

// do card description information
const doCardDescription = (data, valueWithInterest = null) => {
  const { name, amount, description } = data.product || data
  const { value, installments, period } = data.payment
  const formatter = new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
  })

  const itemsCard = {
    'Produto': name,
    'Descrição': description,
    'Quantidade': +amount,
    'N Cobranças': !amount ? installments : null,
    'Intervalo': !periodType[period] ? period : periodType[period],
    'Valor': valueWithInterest || formatter.format(value),
  }

  return (Object.fromEntries(Object.entries(itemsCard).filter(([key, item]) => !!item)))
}

// do installments object for choice installment
const doInstallments = data => {
  const formatter = new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
  })

  const {
    charge_rate, charge_after, installments, value,
  } = data

  let priceWithInterest = value

  const installmentsObject = Array.apply(null, Array(installments)).map((undef, installment) => {
    installment += 1

    if (installment <= charge_after || charge_after == 0) {
      return ({
        value: installment,
        priceWithInterest: formatter.format(value),
        text: `${installment}X ${formatter.format(value / installment)} Sem Juros`,
      })
    }
    priceWithInterest = (+value * +charge_rate) / 100 + (+priceWithInterest)
    return ({
      value: installment,
      priceWithInterest: formatter.format(priceWithInterest),
      text: `${installment}X ${formatter.format(priceWithInterest / installment)} (Juros de ${charge_rate}% a.m)`,
    })
  })

  return installmentsObject
}

const doCardBrand = data => {
  const cardObject = cardValidator.number(data)

  const { card, isPotentiallyValid } = cardObject

  if (!card) {
    return {
      isPotentiallyValid,
      cardImage: null,
    }
  }

  let { type } = card

  if (type !== 'visa' && type !== 'mastercard' && type !== 'american-express' && type !== 'elo' && type !== 'hipercard' && type !== 'diners-club' && type !== 'discover') {
    type = 'default'
  }

  return {
    cardImage: cardBrand[type],
    isPotentiallyValid,
  }
}

export {
  doInstallments,
  doCardDescription,
  doCardBrand,
}
